const INIT_ACTION = '@ngrx/store/init';

export const reduxLocalStorage = () => (reducer: any) => {
    return (state, action) => {
        let nextState;

        try {
            state = JSON.parse(window.localStorage.state || '{}');


            if ((action.type === INIT_ACTION) && !state) {
                nextState = reducer(state, action);
            } else {
                nextState = { ...state };
            }

            nextState = reducer(nextState, action);

            (window as any).localStorage.state = JSON.stringify(nextState);

            return nextState;
        } catch {}
    };
};
